/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "@mui/material";
import { useHistory } from "react-router-dom";
import { sessionNames } from "../../../constants/sessionNames";
import "./Sessions.css";
import Locale from "../../../locales";
import { selectStudent } from "../../../redux/actions";

const DEFAULT_SESSIONS = [
  { title: sessionNames.SESSION1 },
  { title: sessionNames.SESSION2 },
  { title: sessionNames.SESSION3 },
];

const Sessions = ({ summaryStudent }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const updatedSessions = useSelector((state) => state.teacherReducer.sessions);
  const [sessions, setSessions] = useState(DEFAULT_SESSIONS);

  const goToSessionsHandler = () => {
    dispatch(selectStudent(summaryStudent));
    history.push("/tasks");
  };

  useEffect(() => {
    setSessions(DEFAULT_SESSIONS);
  }, [summaryStudent]);

  useEffect(() => {
    if (updatedSessions.length) {
      setSessions(
        // sorting sessions
        updatedSessions.sort((a, b) => {
          const prev = Number(a.title.split(" ")[1]);
          const next = Number(b.title.split(" ")[1]);
          return prev - next;
        }),
      );
    }
  }, [updatedSessions]);
  return (
    <Tooltip arrow title={Locale.t("click_to_manage_sessions")}>
      <div onClick={goToSessionsHandler} className="sessions-summary-container">
        <div className="heading">
          <p>{Locale.t("sessions")}</p>
        </div>
        <div className="sessions-list-container">
          {sessions.map((session) => (
            <div className="sessions-list-item" key={session.title}>
              <p>{session.title}</p>
              {session?.sessionDuration ? (
                <p className="session-duration">
                  {session.sessionDuration} Min
                </p>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </Tooltip>
  );
};

export default Sessions;
